export default __webpack_public_path__ + "static/media/steven.190d2944.jpg";